module.exports = __webpack_public_path__ + "img/example.f43622d1.png";